import {
  ConversationProvider,
  ConversationStore,
} from "../store/conversationStore";
import { useConversationsStore } from "../store/conversationsStore";
import { useSubscribe } from "@deputy-ai/common/observable";
import { useCreation } from "ahooks";
import type { PropsWithChildren } from "react";
import { catchError, EMPTY } from "rxjs";

export type InitConversationProviderProps = PropsWithChildren<{
  conversationUid: string;
}>;
export function InitConversationProvider(props: InitConversationProviderProps) {
  const { conversationUid, children } = props;
  const {
    use: { deployment },
    bind: { setStoragedConversation },
  } = useConversationsStore();

  const store = useCreation(() => {
    if (!deployment) {
      return null;
    }
    return new ConversationStore({
      deployment,
      conversationUid,
    });
  }, [conversationUid]);

  useSubscribe(
    () =>
      store?.init()?.pipe(
        catchError(() => {
          setStoragedConversation();
          return EMPTY;
        })
      ),
    [store]
  );

  if (!store) {
    return null;
  }

  return <ConversationProvider store={store}>{children}</ConversationProvider>;
}
